import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }, [
      _createElementVNode("path", { d: "m20.257 9.65-15.9-7.9c-1.6-.9-3.4.8-2.7 2.5l5.5 13.6-5.5 13.6c-.7 1.7 1.1 3.4 2.7 2.5l3-1.5M12.957 29.65l20.1-10c1.5-.7 1.5-2.8 0-3.6l-8-4M33.857 17.85h-20.9" })
    ], -1)
  ]))]))
}
export default { render: render }